module.exports = __webpack_public_path__ + "static/fonts/ac-icons.08c766fd.woff";